module.exports = __webpack_public_path__ + "img/ie.fb096898.svg";